// Native-only behaviour for the iOS/Android app shell. Loaded on demand so
// the website's bundle stays empty for browsers.
if (window.Capacitor?.isNativePlatform?.()) {
    import('./native/app-shell.js');
    import('./native/purchases.js');
    import('./native/push.js');
}
